module.exports = __webpack_public_path__ + "static/don30-f25f6ae425f67bb6450b30a69a1c2277.jpg";